(function () {
  function scanReveal(observer, order) {
    var els = document.querySelectorAll('[data-reveal]:not([data-shown]):not([data-obs])');
    els.forEach(function (el) {
      el.setAttribute('data-obs', '1');

      if (!observer) {
        el.setAttribute('data-shown', '1');
        return;
      }

      var parent = el.parentElement;
      var i = order.get(parent) || 0;
      order.set(parent, i + 1);
      el.style.setProperty('--d', Math.min(i, 7) * 70 + 'ms');

      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.setAttribute('data-shown', '1');
        return;
      }

      observer.observe(el);
    });
  }

  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var order = new Map();
    var observer = null;

    if (!reduce && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-shown', '1');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
      );
    }

    scanReveal(observer, order);

    var mo = new MutationObserver(function () {
      scanReveal(observer, order);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-reveal][data-obs]').forEach(function (el) {
        el.removeAttribute('data-obs');
        el.removeAttribute('data-shown');
      });
    });
  }
})();
